{
    "useCases": [
        {
            "id": "advantage-products",
            "title": "Advantage Products Price List",
            "icon": "pi-dollar",
            "description": "Get current pricing for Ballance Advantage products and Nutrient Elements. I can retrieve the latest price list information directly from the Ballance website."
        },
        {
            "id": "agent-memory",
            "title": "Agent Memory",
            "icon": "pi-database",
            "description": "I can remember important context about you and your farm across conversations. Share details about your operation and I'll recall them in future chats."
        },
        {
            "id": "conversation-history",
            "title": "Conversation History",
            "icon": "pi-history",
            "description": "Ask about previous messages or earlier parts of our conversation. I can retrieve and summarise what we've discussed."
        },
        {
            "id": "foundation-documents",
            "title": "Foundation Documents",
            "icon": "pi-book",
            "description": "Access Ballance's most authoritative sources containing core agronomic guidance, approved product information, and official recommendations."
        },
        {
            "id": "general-questions",
            "title": "General Questions",
            "icon": "pi-question-circle",
            "description": "Ask any other questions about farming, agronomy, or Ballance products. I'll do my best to help using available resources."
        },
        {
            "id": "image-analysis",
            "title": "Image Analysis",
            "icon": "pi-image",
            "description": "Upload images related to New Zealand farming for analysis. Get insights combined with knowledge base information."
        },
        {
            "id": "product-compatibility",
            "title": "Product Compatibility",
            "icon": "pi-link",
            "description": "Find out which products can be blended, mixed, or used together. Get guidance on tank mixes and product combinations."
        },
        {
            "id": "product-information",
            "title": "Product Information",
            "icon": "pi-shopping-bag",
            "description": "Get detailed product information including pricing, composition, nutrient content, application rates, and usage guidelines for Ballance products."
        },
        {
            "id": "pure-products-organic",
            "title": "Pure Products & Organic",
            "icon": "pi-verified",
            "description": "Explore Ballance's BioGro certified organic range. Get information on Pure products and their organic certification status."
        },
        {
            "id": "sustain-products",
            "title": "SustaiN Products",
            "icon": "pi-box",
            "description": "Get application recommendations for SustaiN products that comply with label requirements and technical specifications."
        },
        {
            "id": "uploaded-files",
            "title": "Uploaded Files",
            "icon": "pi-upload",
            "description": "Analyse your uploaded documents and images. Upload PDFs or images and ask questions about their content."
        },
        {
            "id": "user-preferences",
            "title": "User Preferences",
            "icon": "pi-sliders-h",
            "description": "Tell me how you prefer to receive answers—brief or detailed, technical or plain language, metric or imperial units. I'll remember for all future conversations."
        }
    ]
}
